

// initial state
const state = {
    loaderOverlay: true,
    loader: false,
    emptyPage: false,
    locale: 'nl',
    snackbar: {
      color: '',
      show: false,
      text: 'Nothing wrong'
    },
    popups: {
      alarms: false,
      selectTag: false,
    },
    mainMenu: [
      {
        title: 'Dashboard',
        icon: 'mdi-home',
        to: '/dashboard',
      },
      {
        title: 'Grafieken',
        icon: 'mdi-chart-line',
        to: '/charts',
      },
      {
        title: 'Logs',
        icon: 'mdi-archive-outline',
        to: '/logs',
      },
      {
        title: 'Reporters',
        icon: 'mdi-tag-text-outline',
        to: '/reporters',
      },
      
    ],
    selected: {
      device: null,
      reporter: null
    },
    selectedTags: [],
    exportTag: null
};

// getters
const getters = {

    selectedTags(state){
      return state.selectedTags
    },
    selected(state){
      return state.selected
    },
    data(state){
      return state
    },
    loaderOverlay(state){
      return state.loaderOverlay
    },
    loader(state){
      return state.loader
    },
    exportTag(state){
      return state.exportTag
    }

};

// actions
const actions = {

//   getAllProducts ({ commit }) {
//     shop.getProducts(products => {
//       commit('setProducts', products)
//     })
//   }

}

// mutations
const mutations = {

  setSelected(state, data){
    state.selected[data.name] = data.value ;
  },

  setSelectedTag(state, tag){

    // console.log(state.selected);
    
    tag.device = state.selected.device ;
    tag.reporter = state.selected.reporter ;

    // console.log('----');
    // console.log(tag.device);
    // console.log(tag);
    // console.log('----');

    let index = state.selectedTags.findIndex(function( obj ) {
        return obj.id === tag.id;
    });

    if(index !== -1){
      state.selectedTags.splice(index, 1, tag) ;
    }else{
      state.selectedTags.push(tag) ;
    }

    console.log(tag);

    state.selected = {
      device: null,
      reporter: null
    }

    state.popups.selectTag = false ;
    
  },
  setSelectedChartTag(state, tag){
    
    state.selectedTags = [];
    
    tag.device = state.selected.device ;
    tag.reporter = state.selected.reporter ;
    
    state.selectedTags.push(tag) ;
    
    state.selected = {
      device: null,
      reporter: null
    }


  },setSelectedTags(state, selectedTags){
    
    state.selectedTags = selectedTags ;
    
  }, 
  setExportTag(state, exportTag){

    exportTag.device = state.selected.device ;
    exportTag.reporter = state.selected.reporter ;
    state.exportTag = exportTag ;
    
  },

  setPopup(state, popup){
    state.popups[popup.name] = popup.value ;
  },

  setLocale(state, locale){
    state.locale = locale ;
  },

  hideOverlay (state) {
    state.loaderOverlay = false
  },

  popUpSelectTag (state){
    state.popups.selectTag = true;
  },

  SET_LOADER (state, loader) {
    state.loader = loader
  },

  SET_SNACKBAR (state, snackbar) {
    state.snackbar = snackbar
  },

  SET_ERROR (state, errorMessage) {

    let message = ''; 

    if(errorMessage.response){
      message = errorMessage.response.data.error.message+" ("+errorMessage.response.data.error.code+")" ; 
      //console.error(errorMessage.response);
    }else{
      message = errorMessage ; 
      //console.error(errorMessage) ;
    }

    let snackbar = {
        color: 'red',
        show: true,
        text: message
    }
    
    state.snackbar = snackbar

    this.commit("app/SET_LOADER", false) ;

  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}